import { render, staticRenderFns } from "./shiping.vue?vue&type=template&id=04eaae71&"
import script from "./shiping.vue?vue&type=script&lang=js&"
export * from "./shiping.vue?vue&type=script&lang=js&"
import style0 from "./shiping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports